exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.disabled {\n  pointer-events: none;\n  cursor: not-allowed; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/navbar-responsive/navbar-responsive.component.scss
// module id = ./src/app/navbar-responsive/navbar-responsive.component.scss
// module chunks = main